import {willUseSharedCallback} from '@startlibs/core'


export const [useUpdateParams,callUpdateParams] = willUseSharedCallback()
export const [useRegisterSetParams,setParams] = willUseSharedCallback()